import { render, staticRenderFns } from "./EducationDegree.vue?vue&type=template&id=544af566&scoped=true&"
import script from "./EducationDegree.vue?vue&type=script&lang=js&"
export * from "./EducationDegree.vue?vue&type=script&lang=js&"
import style0 from "./EducationDegree.vue?vue&type=style&index=0&id=544af566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544af566",
  null
  
)

export default component.exports